import React from "react";

import {
  SFCarouselContainer,
  SFVideoThumbnail,
  SFCarouselTitle,
  SFGridContainerItem,
  SFGridItem,
  SFIcons,
} from "@sf-core";

import { useNavigate } from "react-router-dom";
import { getAcademyUrl } from "../../constants/urls";
import { getAcademyIcon } from "../../constants/academyIcons";
import SFHaloIconWrapper from "../../../core/components/icons/halo";

const Academies = ({ title, items = [] }) => {
  const navigate = useNavigate();
  return (
    <SFGridContainerItem>
      <SFGridItem xs={12}>
        {title && <SFCarouselTitle>{title}</SFCarouselTitle>}
        <SFCarouselContainer perPage={3}>
          {items.map((item, index) => {
            const progress =
              (item.completedDuration / item.totalDuration) * 100;
            return (
              <SFVideoThumbnail
                onClick={() => navigate(getAcademyUrl(item.id))}
                key={`${item.name}-${index}`}
                title={item.name}
                icon={
                  progress == 100 ? (
                    <SFHaloIconWrapper size="large" variant="green">
                      <SFIcons.SFCompletedIcon size="xxlarge" />
                    </SFHaloIconWrapper>
                  ) : (
                    getAcademyIcon(item.thumbnail, true)
                  )
                }
                video={item.previewVideo}
                progress={progress}
              />
            );
          })}
        </SFCarouselContainer>
      </SFGridItem>
    </SFGridContainerItem>
  );
};

export default Academies;
